// We're going to detect when the device goes offline, and show a message at
// the bottom of the page.
//
// To try it out, in Chrome DevTools enter responsive mode, and look for the
// network toggle, it should read "Online", change it to "Offline".
import React                 from 'react';
import WithoutPaddingInViews from '../components/without_padding_in_views';


export default class OfflineIndicator extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOffline: false
    };

    this.onOffline = this.onOffline.bind(this);
    this.onOnline  = this.onOnline.bind(this);
  }

  componentDidMount() {
    window.addEventListener('offline', this.onOffline);
    window.addEventListener('online', this.onOnline);
  }

  componentWillUnmount() {
    window.removeEventListener('offline', this.onOffline);
    window.removeEventListener('online', this.onOnline);
  }

  onOffline() {
    this.setState({ isOffline: true });
  }

  onOnline() {
    this.setState({ isOffline: false });
  }

  render() {
    const { isOffline } = this.state;
    if (isOffline) {
      return (
        <WithoutPaddingInViews position="bottom" className="offline_indicator">
          <span>No network connection</span>
        </WithoutPaddingInViews>
      );
    } else
      return null;
  }
}
